// This file is auto-generated by the release scrip
export const version = '2.89.8';
